class SnippetFilterPrice {
  constructor(root) {
    this.root = root;
    if (!this.root || this.root.dataset.filterPriceInited === 'true') return;
    this.progress = this.root.querySelector('.progress');
    this.minParamInput = this.root.querySelector('.js-min-param');
    this.maxParamInput = this.root.querySelector('.js-max-param');
    this.minDisplay = this.root.querySelector('.js-min-display');
    this.maxDisplay = this.root.querySelector('.js-max-display');
    this.minInput = this.root.querySelector('.min-input');
    this.maxInput = this.root.querySelector('.max-input');
    this.form = this.root.closest('form');

    // Get currency data from data attributes
    this.currencySymbol = this.root.dataset.currencySymbol || '€';
    this.moneyFormat = this.root.dataset.moneyFormat || '{{ money }}';

    if (!this.progress || !this.minInput || !this.maxInput) return;

    this.isDragging = false;
    this.startOffsetX = 0;
    this.debounceTimer = undefined;

    this.onRangeMinInput = this.onRangeMinInput.bind(this);
    this.onRangeMaxInput = this.onRangeMaxInput.bind(this);
    this.onProgressMouseDown = this.onProgressMouseDown.bind(this);

    this.root.dataset.filterPriceInited = 'true';
    this.bind();
    this.updateProgress();
  }

  formatMoney(amount) {
    // Format like Shopify's money filter without trailing zeros
    const formattedNumber = new Intl.NumberFormat('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
    
    // Add currency symbol based on Shopify's money format
    // Most common format is "{{ money }}" which puts symbol after the number
    if (this.moneyFormat.includes('{{ money }}')) {
      return formattedNumber + this.currencySymbol;
    } else {
      // Fallback to symbol before number
      return this.currencySymbol + formattedNumber;
    }
  }

  updateProgress() {
    const minValue = parseInt(this.minInput.value, 10);
    const maxValue = parseInt(this.maxInput.value, 10);

    const range = parseInt(this.maxInput.max, 10) - parseInt(this.minInput.min, 10);
    const valueRange = maxValue - minValue;
    const width = (valueRange / range) * 100;
    const minOffset = ((minValue - parseInt(this.minInput.min, 10)) / range) * 100;

    this.progress.style.width = width + '%';
    this.progress.style.left = minOffset + '%';

    if (this.minDisplay) this.minDisplay.textContent = this.formatMoney(minValue);
    if (this.maxDisplay) this.maxDisplay.textContent = this.formatMoney(maxValue);
    this.updateHiddenParams(minValue, maxValue);
  }

  onRangeMinInput() {
    if (parseInt(this.minInput.value, 10) >= parseInt(this.maxInput.value, 10)) {
      this.maxInput.value = this.minInput.value;
    }
    this.updateProgress();
    this.submitDebounced();
  }

  onRangeMaxInput() {
    if (parseInt(this.maxInput.value, 10) <= parseInt(this.minInput.value, 10)) {
      this.minInput.value = this.maxInput.value;
    }
    this.updateProgress();
    this.submitDebounced();
  }

  onProgressMouseDown(e) {
    e.preventDefault();
    this.isDragging = true;
    this.startOffsetX = e.clientX - this.progress.getBoundingClientRect().left;
    this.root.classList.toggle('dragging', this.isDragging);
  }

  onDocumentMouseMove(e) {
    if (!this.isDragging) {
      this.root.classList.toggle('dragging', this.isDragging);
      return;
    }

    const sliderRect = this.root.getBoundingClientRect();
    const progressWidth = parseFloat(this.progress.style.width || '0');

    let newLeft = ((e.clientX - sliderRect.left - this.startOffsetX) / sliderRect.width) * 100;
    newLeft = Math.min(Math.max(newLeft, 0), 100 - progressWidth);

    this.progress.style.left = newLeft + '%';

    const range = parseInt(this.maxInput.max, 10) - parseInt(this.minInput.min, 10);
    const newMin = Math.round((newLeft / 100) * range) + parseInt(this.minInput.min, 10);
    const newMax = newMin + (parseInt(this.maxInput.value, 10) - parseInt(this.minInput.value, 10));

    this.minInput.value = String(newMin);
    this.maxInput.value = String(newMax);
    this.updateProgress();
    this.root.classList.toggle('dragging', this.isDragging);
  }

  onDocumentMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
    }
    this.root.classList.toggle('dragging', this.isDragging);
    this.submitDebounced();
  }

  bind() {
    this.minInput.addEventListener('input', this.onRangeMinInput);
    this.maxInput.addEventListener('input', this.onRangeMaxInput);
    this.progress.addEventListener('mousedown', this.onProgressMouseDown);
  }

  updateHiddenParams(minEuro, maxEuro) {
    if (!this.minParamInput || !this.maxParamInput) return;
    this.minParamInput.value = String(minEuro);
    this.maxParamInput.value = String(maxEuro);
  }

  submitDebounced(delay = 300) {
    if (!this.form) return;
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      // Ensure hidden params are in sync before submit
      const min = parseInt(this.minInput.value, 10);
      const max = parseInt(this.maxInput.value, 10);
      this.updateHiddenParams(min, max);
      this.form.submit();
    }, delay);
  }
}

const initializeAllFilterPrice = (scope = document) => {
  const roots = scope.querySelectorAll('.range-slider');
  for (const root of roots) new SnippetFilterPrice(root);
};

document.addEventListener('DOMContentLoaded', () => {
  initializeAllFilterPrice(document);
});